// freeNadLink.js
// The free NAD+ claim link in the quiz's "Welcome back!" box.
//
// A returning paid patient gets a "Claim My Free NAD+" button to the members
// page, but only when the link they came in on names a NAD+: `?nad=nasal` or
// `?nad=injection` (Ale, 2026-11-03). `offer` and `med` do not count. The same
// rule as gorxpros lib/free-nad-life.ts linkNamesNad().

/** The members page the button opens. */
export const FREE_NAD_CLAIM_PATH = '/free-nad-claim/';

/**
 * The NAD+ a route's query names, 'nasal' or 'injection', or '' for none.
 * Takes `this.$route.query`. A repeated `nad` counts by its first value, as
 * URLSearchParams.get reads it.
 */
export function linkNad(query) {
    const raw = query ? query.nad : undefined;
    const first = Array.isArray(raw) ? raw[0] : raw;
    const form = String(first == null ? '' : first).trim().toLowerCase();
    return form === 'nasal' || form === 'injection' ? form : '';
}
